import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../features/User/UserSlice";
import habitReducer from "../features/Habit/HabitSlice";
import diaryReducer from "../features/Diary/DiarySlice";

export const store = configureStore({
  reducer: { user: userReducer, habit: habitReducer, diary: diaryReducer },
  devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;
